import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import qs from 'qs'

Vue.config.productionTip = false

/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Vue.prototype.$qs = qs

/* axios设置 */
import {ajax} from '@/until/httpApi'
Vue.prototype.$ajax = ajax;

Vue.prototype.$extend = function () {
  return Object.assign({}, ...arguments)
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
